import { NgModule } from '@angular/core';
import {CanMatchFn, RouterModule, Routes} from '@angular/router';
import { FullComponent } from './full/full.component';

export const canMatchFullAccess: CanMatchFn = (route, segments) =>
  localStorage.getItem('ROLE')?.toUpperCase() != "LIMITED";


export const AppRoutes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./release-notes/release-notes.module').then(m => m.ReleaseNotesModule)
      },
      {
        path: 'home',
        loadChildren: () => import('./release-notes/release-notes.module').then(m => m.ReleaseNotesModule)
      },
      {
        path: 'release-notes',
        loadChildren: () => import('./release-notes/release-notes.module').then(m => m.ReleaseNotesModule)
      },
      {
        path: 'meter-data',
        loadChildren: () => import('./live-meter/meter/meter.module').then(m => m.MeterModule)
      },
      {
        path: 'manage-teams',
        loadChildren: () => import('./team/team.module').then(m => m.TeamModule),
        canMatch:[canMatchFullAccess]
      },
      {
        path: 'hierarchy-stats',
        loadChildren: () => import('./hierarchy-stats/hierarchy-stats.module').then(m => m.HierarchyStatsModule),
        canMatch:[canMatchFullAccess]
      },
      {
        path: 'profile',
        loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'photos',
        loadChildren: () => import('./photos/photos.module').then(m => m.PhotosModule)
      },
      {
        path: 'search-users',
        redirectTo: '/search/users'
      },
      {
        path: 'search-meters',
        redirectTo: '/search/meters'
      },
      {
        path: 'search-work-orders',
        redirectTo: '/search/work-orders'
      },
      {
        path: 'search',
        loadChildren: () => import('./search/search.module').then(m => m.SearchModule)
      },
      {
        path: 'live-view',
        loadChildren: () => import('./live-meter/live/live.module').then(m => m.LiveModule)
      },
      {
        path: 'rma',
        loadChildren: () => import('./rma/rma.module').then(m => m.RmaModule)
      },
      {
        path: 'team-profile',
        loadChildren: () => import('./team-profile/team-profile.module').then(m => m.TeamProfileModule),
        canMatch:[canMatchFullAccess]

      },
      {
        path: '404',
        loadChildren: () => import('./not-found/not-found.module').then(m => m.NotFoundModule)
      }]
  },
  {
    path: '**',
    redirectTo: '/404'
  }];

@NgModule({
  imports: [
    RouterModule.forRoot(AppRoutes, {
      useHash: false,
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

